import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class OptInSourceForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-9">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="redirect_url"
                            labelKey="url"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Feliratkozáskor átirányítás"
                        />
                    </div>
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="email_template"
                            labelKey="token"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Feliratkozáskor e-mail-sablon"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(OptInSourceForm);
